import * as React from "react";
import * as echarts from "echarts/core";
import type { EChartsCoreOption } from "echarts/core";

/** Renders ``option`` into the returned element and keeps the chart sized to it. Memoize ``option``. */
export const useEChart = (option: EChartsCoreOption) => {
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!ref.current) return;
    const chart = echarts.init(ref.current, undefined, { renderer: "canvas" });
    chart.setOption(option, true);
    const resize = () => chart.resize();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(resize);
    observer?.observe(ref.current);
    window.addEventListener("resize", resize);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", resize);
      chart.dispose();
    };
  }, [option]);
  return ref;
};
